module.exports = __webpack_public_path__ + "static/lageplan-c2ef135e264842d33d758e7eec37c065.png";